import {Component, ViewChild, Output, Input, EventEmitter, ElementRef} from '@angular/core';
import { ModalDirective} from "ng2-bootstrap";
import {ToasterService} from "angular2-toaster";
import {NotesService} from "../../models/notes/notes.service";
import {NotesType} from "../../models/notes/notes.type";
import {Roles} from "../../models/roles";
import {CompaniesService} from "../../models/companies/companies.service";
import {CompaniesModel} from "../../models/companies/companies.model";
import * as _ from "lodash";
import {ValidationService} from "../../services/validation.service";
import {dateTimeHelper} from "../../helpers/date";

@Component({
    selector: 'client-notes',
    templateUrl: 'client-notes.template.html',
    exportAs: 'snowNotes',
    styleUrls:['client-notes.component.css'],
})
export class ClientNotesComponent {

    public newNote: string = null;
    public $notesForm;
    public notesType = NotesType;

    private notes: Array<any> = [];
    private personData: any;
    private companies: Array<CompaniesModel> = [];

    @ViewChild('modalTemplate') public modalTemplate: ModalDirective;
    @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() isLead: any = false;


    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        public rolesService: Roles,
        public companiesService: CompaniesService,
        private toasterService: ToasterService,
        protected el: ElementRef,
        protected notesService: NotesService,
        protected validationService: ValidationService
    ) {

    }

    ngAfterViewInit() {
        this.$notesForm = $('[name="notes-form"]', this.el.nativeElement);
        this.validateForm();
    }

    ngOnInit() {
        //todo refactor this with StaticDataService
        this.loadCompanies();
    }


    // ===========================================================
    // Load Data
    // ===========================================================

    private loadCompanies() {
        this.companiesService.getList()
            .subscribe(
                (res) => {
                    this.companies = res.data;
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    console.log(errorData.message);
                });
    }


    // ===========================================================
    // Actions
    // ===========================================================

    public hide() {
        this.modalTemplate.hide();
    }

    public show(person) {

        this.$notesForm[0].reset();

        this.personData = person;
        this.notes = person.notes;

        this.readNotes();
        this.modalTemplate.show();
    }


    // ===========================================================
    // Functions
    // ===========================================================


    private validateForm() {
        this.$notesForm
            .validate({
                submitHandler: (form) => {
                    let noteSendData: any;
                    if (this.isLead === false) {
                        noteSendData = {client_id: this.personData.id, message: this.newNote, type: this.notesType.SALES_NOTE};
                    } else {
                        noteSendData = {lead_id: this.personData.id, message: this.newNote};
                    }
                    this.notesService.add(noteSendData)
                        .subscribe(
                            (res) => {
                                this.notes.unshift(res.data);
                                this.$notesForm[0].reset();

                                this.hide();

                                this.toasterService.pop('success', 'Success', 'Notes saved');
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });

                    return false;

                }
            });
    }

    private readNotes() {
        if(! this.isLead && this.personData && this.personData.id){
            this.notesService.readNote({client_id: this.personData.id})
                .subscribe();
        }
    }

    public getCompanyNameById(ids) {
        let res = '';
        if (Array.isArray(ids)) {
            let companies = this.companies;
            ids.forEach(function(item) {
                let company = _.find(companies, {id: item});
                if(company){
                    res += (res.length == 0 ? '' : ', ') + company.name;
                }
            })
        }
        return res;
    }

    public isValid() {
        return (this.newNote && this.newNote.length > 0) ? true : false;
    }

    dateDisplayFormat(date) {
        try {
            return dateTimeHelper.dateFormatUSA(date, false) + ' ' + dateTimeHelper.get24Time(date, false);
        } catch (e) {
            return '';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/client-notes/client-notes.component.ts